module.exports = __webpack_public_path__ + "img/dowJones.9375dd4d.png";